const sessionKey = 'session';

export const setSession = (session): void => {
  localStorage.setItem(sessionKey, JSON.stringify(session));
};

export const getSession = (): any => {
  const session = localStorage.getItem(sessionKey);
  return JSON.parse(session);
};

export const deleteSession = (): void => {
  setSession(null);
};



// WEBPACK FOOTER //
// /var/www/lantago-app/lantago-app-demo/src/app/core/services/storage.service.ts